var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

// server/utils/colors.js
var require_colors = __commonJS({
  "server/utils/colors.js"(exports, module) {
    function intToRgb(intColor) {
      const red = intColor >> 16;
      const green = intColor - (red << 16) >> 8;
      const blue = intColor - (red << 16) - (green << 8);
      return [red, green, blue];
    }
    function hsbToRgb(hsb, maxSB = 100) {
      const h = hsb[0];
      const s = hsb[1];
      const b = hsb[2];
      const sDivided = s / maxSB;
      const bDivided = b / maxSB;
      const k = (n) => (n + h / 60) % 6;
      const f = (n) => bDivided * (1 - sDivided * Math.max(0, Math.min(k(n), 4 - k(n), 1)));
      return [Math.round(255 * f(5)), Math.round(255 * f(3)), Math.round(255 * f(1))];
    }
    function rgbToHsb(rgb, maxSB = 100) {
      let r = rgb[0];
      let g = rgb[1];
      let b = rgb[2];
      r /= 255;
      g /= 255;
      b /= 255;
      const v = Math.max(r, g, b);
      const n = v - Math.min(r, g, b);
      const h = n === 0 ? 0 : n && v === r ? (g - b) / n : v === g ? 2 + (b - r) / n : 4 + (r - g) / n;
      return [Math.round(60 * (h < 0 ? h + 6 : h)), Math.round(v && n / v * maxSB), Math.round(v * maxSB)];
    }
    function rgbToInt(rgb) {
      const [red, green, blue] = rgb;
      return red << 16 | green << 8 | blue;
    }
    function intToHex(intColor) {
      return `${intColor.toString(16).padStart(6, "0")}`;
    }
    function hexToInt(hexColor) {
      if (hexColor.startsWith("#")) {
        return parseInt(hexColor.substring(1), 16);
      }
      return parseInt(hexColor, 16);
    }
    function kelvinToRGB(kelvin) {
      const temperature = kelvin / 100;
      let red;
      let green;
      let blue;
      if (temperature <= 66) {
        red = 255;
      } else {
        red = temperature - 60;
        red = 329.698727446 * red ** -0.1332047592;
        if (red > 255) {
          red = 255;
        }
      }
      if (temperature <= 66) {
        green = temperature;
        green = 99.4708025861 * Math.log(green) - 161.1195681661;
        if (green < 0) {
          green = 0;
        }
        if (green > 255) {
          green = 255;
        }
      } else {
        green = temperature - 60;
        green = 288.1221695283 * green ** -0.0755148492;
      }
      if (temperature >= 66) {
        blue = 255;
      } else if (temperature <= 19) {
        blue = 0;
      } else {
        blue = temperature - 10;
        blue = 138.5177312231 * Math.log(blue) - 305.0447927307;
        if (blue < 0) {
          blue = 0;
        }
      }
      return [Math.round(red), Math.round(green), Math.round(blue)];
    }
    function getReversedGammaCorrectedValue(value) {
      return value <= 31308e-7 ? 12.92 * value : (1 + 0.055) * value ** (1 / 2.4) - 0.055;
    }
    function xyToInt(x, y) {
      const xy = {
        x,
        y
      };
      const Y = 1;
      const X = Y / xy.y * xy.x;
      const Z = Y / xy.y * (1 - xy.x - xy.y);
      let r = X * 1.656492 - Y * 0.354851 - Z * 0.255038;
      let g = -X * 0.707196 + Y * 1.655397 + Z * 0.036152;
      let b = X * 0.051713 - Y * 0.121364 + Z * 1.01153;
      r = getReversedGammaCorrectedValue(r);
      g = getReversedGammaCorrectedValue(g);
      b = getReversedGammaCorrectedValue(b);
      const max = Math.max(r, g, b);
      if (max > 1) {
        r /= max;
        g /= max;
        b /= max;
      }
      const red = Math.max(0, Math.round(r * 255));
      const green = Math.max(0, Math.round(g * 255));
      const blue = Math.max(0, Math.round(b * 255));
      return red << 16 | green << 8 | blue;
    }
    var intToHsb = (intColor) => {
      const [r, g, b] = intToRgb(intColor);
      return rgbToHsb([r, g, b]);
    };
    function miredToKelvin(mired) {
      return 1e6 / mired;
    }
    function kelvinToMired(kelvin) {
      return 1e6 / kelvin;
    }
    module.exports = {
      intToRgb,
      rgbToInt,
      intToHex,
      hexToInt,
      xyToInt,
      hsbToRgb,
      rgbToHsb,
      intToHsb,
      miredToKelvin,
      kelvinToMired,
      kelvinToRGB
    };
  }
});
const __cjsModule = require_colors();
export default __cjsModule;
export const intToRgb = __cjsModule.intToRgb;
export const rgbToInt = __cjsModule.rgbToInt;
export const intToHex = __cjsModule.intToHex;
export const hexToInt = __cjsModule.hexToInt;
export const xyToInt = __cjsModule.xyToInt;
export const hsbToRgb = __cjsModule.hsbToRgb;
export const rgbToHsb = __cjsModule.rgbToHsb;
export const intToHsb = __cjsModule.intToHsb;
export const miredToKelvin = __cjsModule.miredToKelvin;
export const kelvinToMired = __cjsModule.kelvinToMired;
export const kelvinToRGB = __cjsModule.kelvinToRGB;
